const generateDeepLink = (path: string, slug: string): string => {
  const dhuwParams = {
    path: `/apps/${slug}`,
  };

  return `${path}?dhuwParams=${encodeURIComponent(JSON.stringify(dhuwParams))}`;
};

export default generateDeepLink;
